import React from 'react';
import './Partners.css';
import partner1 from '../../assets/logo1.png';
import partner2 from '../../assets/logo2.png';
import partner3 from '../../assets/logo3.png';
import partner4 from '../../assets/logo4.png';
import partner5 from '../../assets/logo5.png';
import partner6 from '../../assets/logo6.png';
import partner7 from '../../assets/logo7.png';
import partner8 from '../../assets/logo8.png';
import partner9 from '../../assets/logo9.png';
import partner10 from '../../assets/logo10.png';
import partner11 from '../../assets/logo11.png';
import partner12 from '../../assets/logo12.png';

const PartnersSection = () => {
  const partners = [
    {
      name: "Tulix",
      logo: partner1,
      alt: "Tulix logo"
    },
    {
      name: "Farm to Feed",
      logo: partner9,
      alt: "Farm to Feed logo"
    },
    {
      name: "Network Research",
      logo: partner2,
      alt: "Network Research logo"
    },
    {
      name: "Lipachat",
      logo: partner10,
      alt: "Lipachat logo"
    },
    {
      name: "Partner 5",
      logo: partner8,
      alt: "Partner 5 logo"
    },
    {
      name: "Partner 6",
      logo: partner5,
      alt: "Partner 6 logo"
    },
    {
      name: "Partner 7",
      logo: partner3,
      alt: "Partner 7 logo"
    },
    {
      name: "Partner 8",
      logo: partner6,
      alt: "Partner 8 logo"
    },
    {
      name: "Partner 9",
      logo: partner4,
      alt: "Partner 9 logo"
    },
    {
      name: "Partner 10",
      logo: partner11,
      alt: "Partner 10 logo"
    },
    {
      name: "Partner 11",
      logo: partner7,
      alt: "Partner 11 logo"
    },
    {
      name: "Partner 12",
      logo: partner12,
      alt: "Partner 12 logo"
    },
  ];

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="partner-text-center">
          <h3 className="partner-title">Collaborations</h3>
          <h2 className="partner-heading">
            Empowering the next Generation of Quantum Innovators
          </h2>
        </div>

        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div 
              key={`${partner.name}-${index}`}
              className="partner-item"
              tabIndex="0"
              role="img"
              aria-label={partner.alt}
            >
              <img
                src={partner.logo}
                alt={partner.alt}
                className="partner-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
        
        <div className="scroll-indicator">
          <div>Swipe to see more partners</div>
          <div className="scroll-dots">
            <div className="scroll-dot"></div>
            <div className="scroll-dot"></div>
            <div className="scroll-dot"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;